// extracted by mini-css-extract-plugin
module.exports = {"mobileCategory":"CategoriesDropdown_mobileCategory__tEEyv","desktopCategories":"CategoriesDropdown_desktopCategories__NIjZ2","menu":"CategoriesDropdown_menu__u8ssG"};